import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actionCreators } from '../../data/uploads/actions';
import { actionCreators as actions } from '../../../../data/upload/actions';
import Gdpr from './components/Gdpr';
import Sidebar from './components/Sidebar';
import Files from './components/Files';
import LoadingScreen from '../../../../../../components/Loading';
import s from './Show.module.scss';

const Show = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const { data, isFetching, hasError, hasData } = useSelector(
    state => state.Admin.data.upload
  );

  useEffect(() => {
    if (id) {
      actions.getSingleUpload(id)(dispatch);
    }
  }, [id, dispatch]);

  const deleteSingleUpload = (deliveryId) => {
    actionCreators.deleteSingleUpload(deliveryId)(dispatch);
  };

  const { status, files, timestamp, sender, recipients = [] } = data || {};
  const initialValues = { gdpr: data?.gdpr };

  if (hasData && !isFetching) {
    return (
      <div className={s['show-upload']}>
        <main className={s['main']}>
          <Gdpr
            uploadData={data}
            initialValues={initialValues}
            deleteSingleUpload={deleteSingleUpload}
          />
          {status === 'Complete' && <Files files={files} />}
        </main>
        <Sidebar recipient={recipients[0]} sender={sender} dateRecived={timestamp} />
      </div>
    );
  }

  if (isFetching) return <LoadingScreen />;
  if (hasError) return <div>Fel vid hämtning av data.</div>;

  return null;
};

export default Show;
